import { ROUTES } from 'constants/routes'

const defaultNavigationConfig = ({ user = {} }) =>
  !user?.id
    ? []
    : [
        {
          path: ROUTES.SERVICES,
          key: 'services_list',
          label_key: 'navigation::nav_menu.advertisement_networks',
          icon: 'gramophone',
        },
        {
          path: ROUTES.FINANCE,
          key: 'finance',
          label_key: 'navigation::nav_menu.finance',
          icon: 'card',
          routes: [
            {
              exact: true,
              path: ROUTES.FINANCE_WALLETS,
              key: 'finance/wallets',
              label_key: 'navigation::finance.navigation.wallets',
              icon: 'money',
            },
            {
              exact: true,
              path: ROUTES.FINANCE_INVOICES,
              key: 'finance/invoices',
              label_key: 'navigation::finance.navigation.invoices',
              icon: 'doc',
            },
            {
              exact: true,
              path: ROUTES.FINANCE_PAYMENT_PROFILES,
              key: 'finance/payment-profiles',
              label_key: 'navigation::finance.navigation.payment_profiles',
              icon: 'user',
            },
            {
              exact: false,
              key: 'finance/promised-payment',
              label_key: 'navigation::finance.navigation.promised_payment',
              path: ROUTES.FINANCE_PROMISED_PAYMENT,
              icon: 'time-clock',
            },
          ],
        },
        {
          path: ROUTES.STATISTICS,
          exact: true,
          label_key: 'navigation::statistics.navigation.main',
          key: 'statistics_main',
          icon: 'statistics',
        },
        {
          path: ROUTES.AGENCY_CLIENTS,
          label_key: 'navigation::nav_menu.agency_dashboard',
          key: 'agency/my-agency',
          icon: 'profile',
        },
        ...(user?.is_referral_program_available
          ? [
              {
                exact: true,
                key: 'referral_program',
                label_key: 'navigation::referral.navigation.affiliate_account',
                icon: 'profile-window',
                routes: [
                  {
                    path: ROUTES.REFERRAL_LINKS,
                    exact: true,
                    key: 'referral/links',
                    icon: 'copy-link',
                    label_key: 'navigation::referral.navigation.referral-links',
                  },
                  {
                    path: ROUTES.REFERRAL_CLIENTS,
                    exact: true,
                    key: 'referral/referral-clients',
                    icon: 'users',
                    label_key: 'navigation::referral.navigation.referral-clients',
                  },
                  {
                    path: ROUTES.REFERRAL_PAYOUT_PROFILES,
                    key: 'referral/payout-profiles',
                    label_key: 'navigation::referral.navigation.payout-profiles',
                    icon: 'money-cashUp',
                  },
                ],
              },
            ]
          : [
              {
                exact: true,
                key: 'referral_program',
                label_key: 'navigation::referral.navigation.referral_program',
                icon: 'two-users',
                routes: [
                  {
                    exact: true,
                    path: ROUTES.REFERRALS,
                    key: 'referrals/main',
                    label_key: 'navigation::referral.navigation.referrals',
                    icon: 'users',
                  },
                  {
                    path: ROUTES.REFERRAL_PAYOUT_PROFILES,
                    key: 'referral/payout-profiles',
                    label_key: 'navigation::referral.navigation.payout-profiles',
                    icon: 'input',
                  },
                ],
              },
            ]),
        /* {
          path: ROUTES.BANK_CARDS,
          exact: true,
          key: 'virtual-cards',
          label_key: 'common::nav_menu.bank_cards',
          icon: (
            <Icon
              name={'card-cloud'}
              size={'m'}
            />
          ),
        }, */
        //@TODO вернем на следующем этапе когда меню в финансах научится раздвигаться вправо для 4ого уровня вложенности
        /*{
        key: 'other',
        label_key: 'common::nav_menu.other',
        routes: [*/

        // {
        //   path: ROUTES.PARTNERS,
        //   label_key: 'navigation::nav_menu.partners',
        //   key: 'partners',
        //   icon: <Icon name="money" size="m" />,
        // },
        // {
        //   path: ROUTES.ACCOUNTS_MARKETPLACE,
        //   label_key: 'common::nav_menu.accounts_marketplace',
        //   key: 'accounts_marketplace',
        //   icon: <Icon name="user-add" size="m" />,
        // },

        // {
        //   path: ROUTES.FINANCE,
        //   key: 'finance/wallets',
        //   label_key: 'navigation::nav_menu.finance',
        //   icon: <Icon name="money" size="m" />,
        //   exact: false,
        //   routes: [
        //     {
        //       exact: true,
        //       path: ROUTES.FINANCE_WALLETS,
        //       key: 'finance/wallets',
        //       label_key: 'common::nav_menu.cards',
        //       icon: <Icon name="card" size="m" />,
        //     },
        //     {
        //       exact: true,
        //       path: ROUTES.FINANCE_PAYMENT_PROFILES,
        //       key: 'finance/payment-profiles',
        //       label_key: 'user::navigation.payment-profiles',
        //       icon: <Icon name={'user'} size={'m'} />,
        //     },
        //     {
        //       exact: true,
        //       label_key: 'common::nav_menu.promised_payment_request',
        //       key: 'finance/promised_payment_request',
        //       path: ROUTES.FINANCE_PROMISED_PAYMENT_REQUEST,
        //       icon: <Icon name={'orders'} size={'m'} />,
        //     },
        //   ],
        // },
        /*],
      },*/
      ]

export default defaultNavigationConfig
